import { render, staticRenderFns } from "./BoothsPage.vue?vue&type=template&id=572db41c&scoped=true"
import script from "./BoothsPage.vue?vue&type=script&lang=ts"
export * from "./BoothsPage.vue?vue&type=script&lang=ts"
import style0 from "./BoothsPage.vue?vue&type=style&index=0&id=572db41c&prod&lang=scss&scoped=true"
import style1 from "./BoothsPage.vue?vue&type=style&index=1&id=572db41c&prod&lang=css"
import style2 from "./BoothsPage.vue?vue&type=style&index=2&id=572db41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572db41c",
  null
  
)

export default component.exports